import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  IssueScoCardEodCommand,
  ScoCardEodCommand,
  ScoCardEodView,
} from '@reform-lite/contracts';
import { apiClient } from '@/lib/api-client';

const key = (terminalId: string) => ['sco-card-eod', terminalId] as const;

/** MICRO-46: a lane's open card end-of-day duties, as it last reported them. */
export function useScoCardEod(terminalId: string) {
  return useQuery({
    queryKey: key(terminalId),
    refetchInterval: 15_000,
    queryFn: async (): Promise<ScoCardEodView> => {
      const response = await apiClient.get<ScoCardEodView>('/sco/card-eod', {
        params: { terminalId },
      });
      return response.data;
    },
  });
}

/** MICRO-46: decide one uncertain duty; the lane collects it on its next report. */
export function useIssueScoCardEod() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: IssueScoCardEodCommand): Promise<ScoCardEodCommand> => {
      const response = await apiClient.post<ScoCardEodCommand>('/sco/card-eod/commands', input);
      return response.data;
    },
    onSuccess: (_data, input) => queryClient.invalidateQueries({ queryKey: key(input.terminalId) }),
  });
}
